/**
 * @prop --ltc-switch-label-color: Label color.
 * @prop --ltc-switch-button-color-on: Color of the text or icon.
 * @prop --ltc-switch-button-color-off: Color of the text or icon.
 * @prop --ltc-switch-background-on: Background color for text or icon.
 * @prop --ltc-switch-background-off: Background color for text or icon.
 * @prop --ltc-switch-toggle-fill: Color of circle fill.
 * @prop --ltc-switch-toggle-stroke: Color of the circle's stroke.
 */

@import (reference) '../../../styles/variables.less';
@import (reference) '../../../styles/functions.less';
@import (reference) '../../../styles/themes.less';

@inner-height: 20px;
@padding: 2px;
@height: @inner-height + @padding + @padding;
@width: 60px;
@animation-speed: 100ms;

.theme-white {
  .switch-theme-white();
}

.theme-blue-light {
  .switch-theme-blue-light();
}

.theme-blue-deep {
  .switch-theme-blue-deep();
}

.theme-teal {
  .switch-theme-teal();
}


:host {
  display: inline-block;
  font: @lt-font-primary;
}

label {
  align-items: center;
  color: var(--ltc-switch-label-color);
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  font-family: inherit;
  gap: @spacer-2 @spacer-1;

  &.no-label {
    gap: 0;
  }

  &.on-the-right {
    flex-direction: row-reverse;
  }

  &.on-the-left {
    flex-direction: row;
  }

  &.justify-center {
    justify-content: center;
  }

  &.justify-start {
    justify-content: start;
  }

  &.justify-end {
    justify-content: end;
  }

  .label-text {
    grid-area: label;
  }

  button {
    align-items: center;
    appearance: none;
    border: none;
    border-radius: 100px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    flex-direction: row-reverse;
    flex-shrink: 0;
    font-family: inherit;
    gap: @spacer-2;
    grid-area: switch;
    height: @height;
    outline: none;
    padding: @padding;
    position: relative;
    width: @width;

    svg.toggle-text {
      height: @inner-height;
      padding-left: calc(@inner-height / 3);
      padding-right: calc(@inner-height / 3);
    }

    span.toggle-text {
      font-family: inherit;
      font-weight: bold;
      padding-left: calc(@inner-height / 2);
      padding-right: calc(@inner-height / 2);
      text-transform: uppercase;
      .font-size-em(12);
      .line-height(@inner-height, 12);
    }

    svg.handle {
      fill: var(--ltc-switch-toggle-fill);
      height: @inner-height;
      left: @padding;
      position: absolute;
      stroke: var(--ltc-switch-toggle-stroke);
      transform: translateX(0);
      transition: transform @animation-speed;
      width: @inner-height;
      will-change: transform;
    }

    &.checked {
      flex-direction: row;

      svg.handle {
        transform: translateX(@width - @inner-height - @padding - @padding);
        transition: transform @animation-speed;
      }
    }

    &.text,
    &.icons {
      background-color: var(--ltc-switch-background-off);
      transition: background-color @animation-speed;

      .toggle-text {
        color: var(--ltc-switch-button-color-off);
        fill: var(--ltc-switch-button-color-off);
      }

      &.disabled {
        background-color: @lt-gray-light-1;
      }

      &.checked {
        background-color: var(--ltc-switch-background-on);

        .toggle-text {
          color: var(--ltc-switch-button-color-on);
          fill: var(--ltc-switch-button-color-on);
        }

        &.disabled {
          background-color: @lt-gray-light-1;
        }
      }
    }

    &:focus-within {
      box-shadow: 0 0 0 2px @lt-blue;
    }
  }
}
